export const PRODUCT_TRANSACTION_TYPE = [
  {
    name: 'เข้า',
    direction: 'add',
  },
  {
    name: 'ออก',
    direction: 'desc',
  },
];
export default PRODUCT_TRANSACTION_TYPE;
